export default __webpack_public_path__ + "static/media/tech-blog.67a5a9ae.png";